import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Alink from '../../common/container/alink'
import { getCookie, setCookie } from '../../basic/common/cookie'
import { Api } from '../libs/api'
import LazyImg from '../../common/container/lazyImg'
import { numberFormat } from 'common/util/util'

const Wing = ({ mainTopBannerVisible }) => {
    const userInfo = useSelector(state => state.user.userInfo)
    const [cookieItem, setCookieItem] = useState(JSON.parse(getCookie('latestItemView') === 'undefined' ? '[]' : getCookie('latestItemView'))) // 쿠키에 undefined 잘못넣어서 12월 정도까지 에러처리..
    const [realItem, setRealItem] = useState([])

    const [currentPage, setCurrentPage] = useState(1)
    const [blockPage, setBlockPage] = useState(1)

    const [top, setTop] = useState(0)
    const [position, setPosition] = useState('absolute')
    const [display, setDisplay] = useState('none')
    const [fixTop, setFixTop] = useState(90) // fixed시 높이값

    const [initPositon, setInitPositon] = useState(333) // 기본 높이값
    const [flag, setFlag] = useState(245)  // position 전환점
    const itemView = 3
    const headerHeight = mainTopBannerVisible ? 277 : 197 // header 높이값
    const maxPosition = 323 // 하단 브레이크 위치 (하단에서 부터의 높이)
    const wingHeight = 514 // 레이어 높이
    const isMain = window.isMainDisplay // 메인확인 전역변수
    let domain = window.location.hostname.split('.')[0] // 도메인

    useEffect(() => {
        cookieNullDelete()
        getItemList()
    }, [])

    useEffect(() => {
        scroll()
        window.addEventListener('scroll', scroll)

        return () => {
            window.removeEventListener('scroll', scroll)
        }
    }, [initPositon, flag])

    useEffect(() => {
        init()
        window.addEventListener('onSetWingLocation', init)
        return () => {
            window.removeEventListener('onSetWingLocation', init)
        }
    }, [mainTopBannerVisible])

    useEffect(() => {
        if (currentPage <= blockPage) {
            setBlockPage(Math.ceil(realItem.length/itemView) || 1)
        }
    }, [realItem])

    useEffect(() => {
        if (currentPage > blockPage) {
            setCurrentPage(blockPage)
        }
    }, [blockPage])

    const init = () => {
        const header = document.querySelector('#header')
        if (isMain) {
            const position = headerHeight + 554
            setInitPositon(headerHeight + 554)
            setFlag(position - fixTop)
            setTop(position)
        } else if (domain === 'deal') {
            if (window.location.pathname === '/') {
                const position = headerHeight + 374
                setInitPositon(position)
                setFlag(position - fixTop)
                setTop(position)
            } else {
                const position = headerHeight + 66
                setInitPositon(position)
                setFlag(position - fixTop)
                setTop(position)
            }
        } else if (domain === 'shopping') {
            if (window.location.pathname.split('/')[1] === 'detail') {
                const position = headerHeight + 56
                const fix = fixTop + 60
                setInitPositon(position)
                setFixTop(fix)
                setFlag(position - fix)
                setTop(position)
            }
        } else if (window.isStdpc) {
            const position = headerHeight + 10
            setInitPositon(position)
            setFlag(position - fixTop)
            setTop(position)
        } else if (header) {
            const position = headerHeight + 56
            setInitPositon(position)
            setFlag(position - fixTop)
            setTop(position)
        } else {
            setFlag(245)
            setInitPositon(333)
            setTop(initPositon)
        }
        setDisplay('block')
    }

    const scroll = () => {
        const scrollTop = window.scrollY || window.pageYOffset
        if (scrollTop > flag) {
            setTop(fixTop)
            setPosition('fixed')

            const bodyHeight = document.body.offsetHeight
            if (bodyHeight - fixTop - maxPosition - wingHeight < scrollTop) {
                const top = bodyHeight - scrollTop - maxPosition - wingHeight
                setTop(top)
            }
        } else {
            setTop(initPositon)
            setPosition('absolute')
        }
    }

    const getItemList = async () => {
        const data = {
            items: cookieItem
        }
        try {
            const request = await Api.getLatestItem(data)
            const delData = request.data.result?.items?.filter(v => (
                v.f_sellout !== 2 || v.f_sellout !== 12 // 단종상품은 뺌
            ))
            setRealItem(delData || [])
        } catch (e) {
            console.error(e)
        }
    }

    const cookieNullDelete = () => {
        if (!cookieItem) return
        const isData = cookieItem?.filter(v => v)
        setCookieItem(isData || [])
        setCookie('latestItemView', JSON.stringify(isData), (30*24*60*60), '/', `.pping.${process.env.REACT_APP_TLD}`)
    }

    const arrowBtn = arrow => () => {
        if (arrow === 'prev') {
            if (currentPage === 1) return
            setCurrentPage(currentPage - 1)
        }
        if (arrow === 'next') {
            if (currentPage === blockPage) return
            setCurrentPage(currentPage + 1)
        }
    }

    const deleteItem = id => () => {
        const list = [...realItem]
        const filterList = list.filter(v => v.item_id !== id)
        const filterCookieList = cookieItem.filter(v => v !== id)
        setRealItem(filterList)
        setCookieItem(filterCookieList)
        setCookie('latestItemView', JSON.stringify(filterCookieList), (30*24*60*60), '/', `.pping.${process.env.REACT_APP_TLD}`)
    }

    const onClickTop = () => {
        window.scrollTo(0, 0);
    }
    return (
        <div className="layout_right_wing" style={{ display, top, position }}>
            <ul className="button_group">
                <li>
                    <Alink href={process.env.REACT_APP_CART_URL}>
                        <span className="count" style={{ width: userInfo?.cart.count > 9 ? '20px' : '16px' }}>
                            {userInfo ? (
                                userInfo.cart.count
                            ) : 0}
                        </span>
                        <i className="icon-cart1" />
                        장바구니
                    </Alink>
                </li>
                <li>
                    <Alink href={`https://my2.pping.${process.env.REACT_APP_TLD}/zzim`}>
                        <span className="count" style={{ width: userInfo?.Zzim.count > 9 ? '20px' : '16px' }}>
                            {userInfo ? (
                                userInfo.Zzim.count
                            ) : 0}
                        </span>
                        <i className="icon-heart1" />
                        찜
                    </Alink>
                </li>
            </ul>
            <div className="recently_viewed_products">
                <h6>최근 본 상품 <span>{realItem.length}</span></h6>
                <div className="cont">
                    {realItem.length > 0 ? (
                        <>
                            <div className="product_view">
                                <ul>
                                    {realItem.map((v, i) => {
                                        const baseUrl = `${process.env.REACT_APP_SHOPPING_URL}/detail`
                                        const isAdult = v.cate_f_adult && !v.user_f_adult // 성인인증 썸네일 사용여부
                                        const condition = i < currentPage * itemView && i >= (currentPage - 1) * itemView
                                        const cateChk = v.cate_id.toString().substr(0, 1) === '2'
                                        return (
                                            condition && (
                                                <li key={v.item_id}>
                                                    <button className="closed" onClick={deleteItem(v.item_id)}>
                                                        <i className="icon-close" />
                                                    </button>
                                                    <Alink href={cateChk ? `${baseUrl}/${v.item_id}/${v.idx_b_manager}` : `${baseUrl}/${v.item_id}`}>
                                                        <div className="txt">
                                                            <p className="txt2">{v.maker_and_item_name}</p>
                                                            <p className="txt3">
                                                                {v.f_sellout === 2 || v.f_sellout === 12
                                                                    ? <b className="no_price">단종된 상품입니다.</b>
                                                                    : (
                                                                        (v.f_sellout === 1 || v.f_sellout === 11 || v.price_low === 0 || v.price_low === null)
                                                                            ? (cateChk) ? <b className="no_price">일시품절</b> : <b className="no_price">가격비교예정</b>
                                                                            : <>최저<b>{numberFormat(v.price_low)}</b>원</>
                                                                    )
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className="thumb">
                                                            <LazyImg imgPath={v.thumbnail} alt={v.item_name} isAdult={isAdult} />
                                                        </div>
                                                    </Alink>
                                                </li>
                                            )
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className="page">
                                <span className="num">
                                    <span>{currentPage}</span>/{blockPage}
                                </span>
                                <div className="control">
                                    <button onClick={arrowBtn('prev')}><i className="icon-angle-right"/></button>
                                    <button onClick={arrowBtn('next')}><i className="icon-angle-right"/></button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <p className="no_item">최근 본 상품이<br/>없습니다</p>
                    )}
                </div>
            </div>
            <button className="top_btn" onClick={onClickTop}>
                <i className="icon-top" />
                TOP
            </button>
        </div>
    )
}

export default Wing



// WEBPACK FOOTER //
// ./src/header/component/wing.js